/** @format */

import axios from "axios";
import { Input } from "antd";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useMemo, useRef, useState } from "react";

import pdf from "../../../../icons/pdf.png";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { header } from "../../../../components/api/Header";
import { monthName } from "../../../../components/functions/Month";
import LoadingCard from "../../../../components/loading/loadingCard";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";
import { formatReservoirName } from "./helpers";

const EXPORT_TITLE = "Oylik hisobot";
const TABLE_SUBTITLE =
  "Markaziy Osiyo Davlatlararo va O'zbekiston Respublikasi suv omborlari ishlashi haqida oylik hisobot";
const DEKADA_KEYS = ["d1", "d2", "d3"];

const formatMonthlyExportDate = (value) => {
  if (!value) {
    return "";
  }

  return `${value.slice(0, 4)} ${monthName(value)}`;
};

function Table5({ date, setOmbor, setLoading, loading }) {
  const conponentPDF = useRef();
  const [report, setReport] = useState({
    year: "",
    month_name: "",
    dekadas: [],
    rows: [],
  });
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${getEnv("REACT_APP_BASE_URL")}/v1/republik/suvombor/oylik-hisobot?date=${date}`,
          header()
        );
        setReport(res.data || {});
      } catch (e) {
        console.log("Xato", e);
        alert("Bazaga bog'lanishda xato");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [date, setLoading]);

  const visibleRows = useMemo(() => {
    const text = searchText.trim().toUpperCase();
    const rows = Array.isArray(report.rows) ? report.rows : [];

    if (!text) {
      return rows;
    }

    return rows.filter((row) => {
      if (row.type !== "data") {
        return false;
      }

      return String(row.name || "").toUpperCase().includes(text);
    });
  }, [report.rows, searchText]);

  const dekadaLabels = useMemo(() => {
    const source = Array.isArray(report.dekadas) ? report.dekadas : [];

    return DEKADA_KEYS.map((key, index) => {
      return source[index]?.label || `${index + 1} dek`;
    });
  }, [report.dekadas]);

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: EXPORT_TITLE,
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button
              onClick={() => Pdf("so5", true, formatMonthlyExportDate(date))}
              className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint(
                  "Dekada",
                  "Sheet 1",
                  "so5",
                  formatMonthlyExportDate(date)
                )
              }>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      {loading ? (
        <LoadingCard loading={loading} heightSize='80vh' />
      ) : (
        <div className='table-responsive tableFixHead' id='tableFlexible'>
          <div ref={conponentPDF} style={{ width: "100%" }}>
            <table
              className='table table-bordered table-style suv-reservoir-table'
              id='so5'>
              <thead>
                <tr>
                  <th colSpan={10} scope='col'>
                    {TABLE_SUBTITLE}
                  </th>
                </tr>

                <tr>
                  <th rowSpan={2} scope='col'>
                    Suv omborlari
                  </th>
                  <th colSpan={3} scope='col'>
                    Hajm (mln. m<sup>3</sup>)
                  </th>
                  <th colSpan={3} scope='col'>
                    Suv kelishi (m<sup>3</sup>/s)
                  </th>
                  <th colSpan={3} scope='col'>
                    Suv chiqarish (m<sup>3</sup>/s)
                  </th>
                </tr>

                <tr>
                  {dekadaLabels.map((label) => (
                    <th key={`volume-${label}`} scope='col'>
                      {label}
                    </th>
                  ))}
                  {dekadaLabels.map((label) => (
                    <th key={`inflow-${label}`} scope='col'>
                      {label}
                    </th>
                  ))}
                  {dekadaLabels.map((label) => (
                    <th key={`outflow-${label}`} scope='col'>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {visibleRows.map((row, index) => {
                  if (row.type === "group") {
                    return (
                      <tr className='table-one-row j-tr' key={index}>
                        <td colSpan={10}>{row.name}</td>
                      </tr>
                    );
                  }

                  return (
                    <tr className='data-tr' key={index}>
                      <td className='text-start fix-with'>
                        <NavLink
                          style={{ color: "#222" }}
                          to={"/suvomborlari/" + row.id}
                          onClick={() =>
                            setOmbor({
                              nomi: row.name,
                              location: [row.lat, row.lan],
                            })
                          }>
                          {formatReservoirName(row.name)}
                        </NavLink>
                      </td>

                      {renderMetricValues(row.volume)}
                      {renderMetricValues(row.inflow)}
                      {renderMetricValues(row.outflow)}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default Table5;

const renderMetricValues = (values = []) =>
  DEKADA_KEYS.map((key, index) => (
    <td key={key}>{filteredValue(values[index])}</td>
  ));

const filteredValue = (value) => {
  if (value === null || value === undefined || value === "" || value === "undefined") {
    return "-";
  }

  const number = parseFloat(value);
  if (Number.isNaN(number)) {
    return "-";
  }

  const rounded = Math.round((number + Number.EPSILON) * 10) / 10;

  return rounded % 1 === 0 ? Math.floor(rounded) : rounded;
};
